import Toolbar from "@mui/material/Toolbar";
import clsx from "clsx";
import { memo } from "react";
import NavbarToggleButton from "@/components/theme-layouts/components/navbar/NavbarToggleButton";
import useFuseLayoutSettings from "@fuse/core/FuseLayout/useFuseLayoutSettings";
import FullScreenToggle from "../../components/FullScreenToggle";
import NavigationSearch from "../../components/navigation/NavigationSearch";
import QuickPanelToggleButton from "../../components/quickPanel/QuickPanelToggleButton";
import { Layout1ConfigDefaultsType } from "@/components/theme-layouts/layout1/Layout1Config";
import useThemeMediaQuery from "../../../../@fuse/hooks/useThemeMediaQuery";
import { AppBar, Divider } from "@mui/material";
import ToolbarTheme from "@/contexts/themeContext/ToolbarTheme";
import SelectCompany from "../../components/SelectCompany";
import Logo from "../../components/Logo";
import SensitiveValuesToggleButton from "../../components/SensitiveValuesToggleButton";
import RestricoesRecursoButton from "@/permissoes/components/restricoes-recurso/RestricoesRecursoButton";
import PwaInstallButton from "../../components/PwaInstallButton";

type ToolbarLayout1Props = {
	className?: string;
};

/**
 * The toolbar layout 1.
 */
function ToolbarLayout1(props: ToolbarLayout1Props) {
	const { className } = props;
	const settings = useFuseLayoutSettings();
	const config = settings.config as Layout1ConfigDefaultsType;
	const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down("lg"));

	return (
		<ToolbarTheme>
			<AppBar
				id="fuse-toolbar"
				className={clsx("relative z-20 flex", className)}
				elevation={0}
				sx={(theme) => ({
					background: "linear-gradient(90deg, #091422 0%, #041530 40%, #002d5a 70%)",
					color: theme.vars.palette.text.primary,
					"&::after": {
						content: '""', //Não remover, estilo fica fixado borda
						position: "absolute",
						top: 0,
						left: 0,
						right: 0,
						height: "3px",
						background: "linear-gradient(90deg, #e6215a, #504a99, #76b0bf)",
						pointerEvents: "none",
					},
				})}
			>
				<Toolbar className="min-h-12 gap-1 p-0 md:min-h-14">
					<div className="flex min-w-0 flex-1 items-center gap-2 px-2 md:px-4">
						{config.navbar.display && config.navbar.position === "left" && (
							<div className="flex min-w-0 items-center gap-2">
								<NavbarToggleButton />
								<Logo />
							</div>
						)}
					</div>

					<div className="flex min-w-0 shrink-0 items-center justify-end gap-1 px-1 py-2 md:px-4">
						<SelectCompany />
						<RestricoesRecursoButton />
						<SensitiveValuesToggleButton />
						<PwaInstallButton />
						{!isMobile && <FullScreenToggle />}
						{!isMobile && <NavigationSearch />}
						<QuickPanelToggleButton />
					</div>

					{config.navbar.display && config.navbar.position === "right" && (
						<div className="flex items-center gap-2 px-2 md:px-4">
							{!isMobile && (
								<>
									<Divider orientation="vertical" flexItem variant="middle" />
									<NavbarToggleButton />
								</>
							)}

							{isMobile && <NavbarToggleButton className="h-10 w-10 p-0 sm:mx-2" />}
							<Logo />
						</div>
					)}
				</Toolbar>
			</AppBar>
		</ToolbarTheme>
	);
}

export default memo(ToolbarLayout1);
